import { gql } from "@shared/utils";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";

import { useGqlField } from "../../../../hooks";
import { MultiSelectCheckmark } from "../../../MultiSelectCheckmark";
import VariablePopup from "../DynamicVariables/VariablePopup";

import { DVInlineProps } from "./types";
import { VariableButton } from "./VariableButton";

const EDIT_SUBTYPE = gql`
  mutation UpdateDynamicVariable($id: String!, $value: [String!]) {
    updateDynamicVariable(input: { id: $id, subtype: $value }) {
      _id
      subtype
    }
  }
`;
const EDIT_OUTPUT = gql`
  mutation UpdateDynamicVariable($id: String!, $value: String!) {
    updateDynamicVariable(input: { id: $id, output: $value }) {
      _id
      output
    }
  }
`;
export const fenceTypes: Array<{ name: string; id: string }> = [
  {
    id: "FENCE",
    name: "Fence",
  },
  {
    id: "GATE",
    name: "Gate",
  },
];

const outputs: Array<{ name: string; id: string }> = [
  {
    id: "EXISTS",
    name: "Exists",
  },
  {
    id: "LENGTH",
    name: "Length",
  },
  {
    id: "COUNT",
    name: "Segment Count",
  },
];

export const DVInlineLine: FunctionComponent<DVInlineProps> = ({
  dynamicVariable,
  onVariableDelete,
  removeDynamicVariable,
  activeDynamicVariableId,
  setActiveDynamicVariableId,
  onChange,
  variables,
}) => {
  const [open, setOpen] = useState(false);

  const [subtype, setSubtype] = useGqlField<string[]>(
    dynamicVariable.subtype || [],
    dynamicVariable._id,
    EDIT_SUBTYPE
  );
  const [output, setOutput] = useGqlField(
    dynamicVariable.output,
    dynamicVariable._id,
    EDIT_OUTPUT
  );

  const onModalClose = async () => {
    if (!subtype?.length) {
      variables &&
        onChange?.(variables.filter((v) => v !== dynamicVariable._id));
      await removeDynamicVariable?.({
        variables: {
          input: {
            id: dynamicVariable._id,
          },
        },
      });
      if (onVariableDelete) onVariableDelete?.(dynamicVariable._id);
    }
  };

  return (
    <>
      <VariablePopup
        actions={[]}
        dynamicVariable={dynamicVariable}
        activeDynamicVariableId={activeDynamicVariableId}
        setActiveDynamicVariableId={setActiveDynamicVariableId}
        onCancel={() => {
          setOpen(false);
          onModalClose();
        }}
        onSave={() => {
          setOpen(false);
        }}
        onClose={() => {
          setOpen(false);
        }}
        title="Edit Fence Variable"
        forceOpen={open}
      >
        <VariableButton
          typeLabel="Fence"
          variableType="LINE"
          onClick={() => {
            setOpen(true);
          }}
          line1={(dynamicVariable.subtype || [])
            .map((st) => {
              return fenceTypes.find((t) => t.id === st)?.name || "";
            })
            .join(", ")}
          output={dynamicVariable?.output}
        />
        <Box>
          <MultiSelectCheckmark
            label="Types"
            onChange={(event) => {
              const val = event.target.value as any[];
              setSubtype(val.map((v) => v.id));
            }}
            defaultValue={dynamicVariable?.subtype}
            variants={fenceTypes}
          />
          <FormControl fullWidth sx={{ marginTop: 2 }}>
            <InputLabel>Output</InputLabel>
            <Select
              label="Output"
              variant="outlined"
              onChange={(e, _v) => {
                setOutput(e.target.value);
              }}
              value={output}
            >
              {outputs.map((o: { id: string; name: string }) => {
                return (
                  <MenuItem value={o.id} key={o.id}>
                    {o.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      </VariablePopup>
    </>
  );
};
